/* eslint-disable no-unused-vars */
import { t } from '@lingui/macro';
import React from 'react';
import certificatesActions from '../../../components/certificates/certificates-actions';
import CertificateDisplay from '../../../components/participation-table/certificate-display/certificate-display';
import { END_DATE, START_DATE } from '../../../helpers/constants';
import UrlHelper from '../../../helpers/url-helper';
import css from './single-class.scss';
import {
    BRONZE,
    DIAMOND,
    EMERALD,
    EPIC,
    GOLD,
    LEGEND,
    NEW_TOTAL,
    PAST_TOTAL,
    PLATINUM,
    SILVER
} from '../config/certificate-constants';

export const STUDENT_NAME = 'fullName';
export const GROUP_NAME = 'name';
export const PAST_CERTIFICATES_TOTAL = 'certificateDetails.total';
export const NEW_CERTIFICATES_TOTAL = 'newCertificateDetails.total';
const ACTIVITY_POINTS = 'points.activityPoints';
const LIVE_POINTS = 'points.livePoints';
const TOTAL_POINTS = 'points.total';
const PAST_CERTIFICATES_BRONZE = 'certificateDetails.bronze';
const PAST_CERTIFICATES_SILVER = 'certificateDetails.silver';
const PAST_CERTIFICATES_GOLD = 'certificateDetails.gold';
const NEW_CERTIFICATES_BRONZE = 'newCertificateDetails.bronze';
const NEW_CERTIFICATES_DIAMOND = 'newCertificateDetails.diamond';
const NEW_CERTIFICATES_EMERALD = 'newCertificateDetails.emerald';
const NEW_CERTIFICATES_EPIC = 'newCertificateDetails.epic';
const NEW_CERTIFICATES_GOLD = 'newCertificateDetails.gold';
const NEW_CERTIFICATES_LEGEND = 'newCertificateDetails.legend';
const NEW_CERTIFICATES_PLATINUM = 'newCertificateDetails.platinum';
const NEW_CERTIFICATES_SILVER = 'newCertificateDetails.silver';

export const headerSort = { sortAs: 'nested', sortDir: 'desc' };
const nestedSort = { sortAs: 'number' };
const getNestedValue = (id, value) => {
    // Split the id string by the delimiter ('.') as we want to avoid extending what is returned from the mapped service data.
    const path = id.split('.');

    return path.reduce((acc, part) => acc && acc[part], value);
};
const getCertificateName = (id, name) => {
    const i18n = window.i18n;
    switch (id) {
        case NEW_CERTIFICATES_TOTAL:
            return i18n._(t`Filename - New Certificates - Student - ${name}`);
        case PAST_CERTIFICATES_TOTAL:
            return i18n._(t`Filename - Past Certificates - Student - ${name}`);
        case NEW_CERTIFICATES_BRONZE:
        case PAST_CERTIFICATES_BRONZE:
            return i18n._(t`Filename - Bronze - ${name}`);
        case NEW_CERTIFICATES_SILVER:
        case PAST_CERTIFICATES_SILVER:
            return i18n._(t`Filename - Silver - ${name}`);
        case NEW_CERTIFICATES_GOLD:
        case PAST_CERTIFICATES_GOLD:
            return i18n._(t`Filename - Gold - ${name}`);
        case NEW_CERTIFICATES_EMERALD:
            return i18n._(t`Filename - Emerald - ${name}`);
        case NEW_CERTIFICATES_DIAMOND:
            return i18n._(t`Filename - Diamond - ${name}`);
        case NEW_CERTIFICATES_EPIC:
            return i18n._(t`Filename - Epic - ${name}`);
        case NEW_CERTIFICATES_LEGEND:
            return i18n._(t`Filename - Legend - ${name}`);
        case NEW_CERTIFICATES_PLATINUM:
            return i18n._(t`Filename - Platinum - ${name}`);
        default:
            return '';
    }
};
// TODO: Create a helper function to use in all class and single class
const getCertificateDisplayColumn = ({
    id,
    name,
    type,
    service,
    classroomId,
    isOldCertificates = false
}) => ({
    id,
    name,
    transform: (value) => {
        const requestParams = {
            classroomId,
            startDate: UrlHelper.getQueryParamValue(START_DATE) || null,
            endDate: UrlHelper.getQueryParamValue(END_DATE) || null,
            groupId: value.groupId,
            isForDownload: true,
            type,
            userProfileId: value.id,
            userId: value.userId
        };
        const onSuccessParams = {
            certificateType: type,
            fileNameOverride: getCertificateName(id, value.fullName)
        };
        return (
            <CertificateDisplay
                count={getNestedValue(id, value)}
                requestParams={requestParams}
                service={service}
                onSuccessParams={onSuccessParams}
                isOldCertificates={isOldCertificates}
            />
        );
    }
});

const getSingleClassParticipationPastCertificates = ({
    isExpanded,
    classroomId
}) => {
    const defaultExpandedParams = {
        service: certificatesActions.pastCertificatesDownloadStudentByType,
        classroomId,
        isOldCertificates: true
    };

    if (isExpanded) {
        return {
            cols: [
                {
                    id: 'Past Certificates - Bronze',
                    name: 'Certificates - Bronze'
                },
                {
                    id: 'Past Certificates - Silver',
                    name: 'Certificates - Silver'
                },
                {
                    id: 'Past Certificates - Gold',
                    name: 'Certificates - Gold'
                }
            ],
            colGroups: [
                [
                    {
                        colIds: [
                            PAST_CERTIFICATES_BRONZE,
                            PAST_CERTIFICATES_SILVER,
                            PAST_CERTIFICATES_GOLD
                        ],
                        name: 'Past Certificates - Total',
                        classes: css['total-certificates'],
                        id: PAST_CERTIFICATES_TOTAL
                    }
                ]
            ],
            nestedData: [
                getCertificateDisplayColumn({
                    id: PAST_CERTIFICATES_BRONZE,
                    name: 'Certificates - Bronze',
                    type: BRONZE.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: PAST_CERTIFICATES_SILVER,
                    name: 'Certificates - Silver',
                    type: SILVER.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: PAST_CERTIFICATES_GOLD,
                    name: 'Certificates - Gold',
                    type: GOLD.type,
                    ...defaultExpandedParams
                })
            ]
        };
    }

    return {
        cols: [
            {
                id: 'PAST CERTIFICATES TOTAL',
                name: ''
            }
        ],
        colGroups: [
            [
                {
                    id: PAST_CERTIFICATES_TOTAL,
                    colIds: [PAST_CERTIFICATES_TOTAL],
                    name: 'Past Certificates - Total',
                    classes: css['total-certificates']
                }
            ]
        ],
        nestedData: [
            getCertificateDisplayColumn({
                id: PAST_CERTIFICATES_TOTAL,
                name: 'Past Certificates - Total',
                service:
                    certificatesActions.pastCertificatesDownloadStudentByType,
                type: PAST_TOTAL.type,
                isOldCertificates: true,
                classroomId
            })
        ]
    };
};

const getSingleClassParticipationNewCertificates = ({
    isExpanded,
    classroomId
}) => {
    const defaultStyles = `
        ${css['total-certificates']} 
        ${css['new-certificates']}
    `;
    const defaultExpandedParams = {
        service: certificatesActions.newCertificatesDownloadStudentByType,
        classroomId
    };
    const defaultHeaderClass = isExpanded
        ? `${defaultStyles}${css['new-expanded']}`
        : defaultStyles;

    if (isExpanded) {
        return {
            cols: [
                {
                    id: 'New Certificates - Bronze',
                    name: 'Certificates - Bronze',
                    classes: defaultHeaderClass
                },
                {
                    id: 'New Certificates - Silver',
                    name: 'Certificates - Silver',
                    classes: defaultHeaderClass
                },
                {
                    id: 'New Certificates - Gold',
                    name: 'Certificates - Gold',
                    classes: defaultHeaderClass
                },
                {
                    id: 'New Certificates - Platinum',
                    name: 'Certificates - Platinum',
                    classes: defaultHeaderClass
                },
                {
                    id: 'New Certificates - Emerald',
                    name: 'Certificates - Emerald',
                    classes: defaultHeaderClass
                },
                {
                    id: 'New Certificates - Diamond',
                    name: 'Certificates - Diamond',
                    classes: defaultHeaderClass
                },
                {
                    id: 'New Certificates - Epic',
                    name: 'Certificates - Epic',
                    classes: defaultHeaderClass
                },
                {
                    id: 'New Certificates - Legend',
                    name: 'Certificates - Legend',
                    classes: defaultHeaderClass
                }
            ],
            colGroups: [
                [
                    {
                        colIds: [
                            NEW_CERTIFICATES_BRONZE,
                            NEW_CERTIFICATES_SILVER,
                            NEW_CERTIFICATES_GOLD,
                            NEW_CERTIFICATES_PLATINUM,
                            NEW_CERTIFICATES_EMERALD,
                            NEW_CERTIFICATES_DIAMOND,
                            NEW_CERTIFICATES_EPIC,
                            NEW_CERTIFICATES_LEGEND
                        ],
                        name: 'New Certificates - Total',
                        classes: isExpanded
                            ? `
                                ${defaultStyles}
                                ${css['new-expanded']}`
                            : defaultStyles,
                        id: NEW_CERTIFICATES_TOTAL
                    }
                ]
            ],
            nestedData: [
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_BRONZE,
                    name: 'Certificates - Bronze',
                    type: BRONZE.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_SILVER,
                    name: 'Certificates - Silver',
                    type: SILVER.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_GOLD,
                    name: 'Certificates - Gold',
                    type: GOLD.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_PLATINUM,
                    name: 'Certificates - Platinum',
                    type: PLATINUM.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_EMERALD,
                    name: 'Certificates - Emerald',
                    type: EMERALD.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_DIAMOND,
                    name: 'Certificates - Diamond',
                    type: DIAMOND.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_EPIC,
                    name: 'Certificates - Epic',
                    type: EPIC.type,
                    ...defaultExpandedParams
                }),
                getCertificateDisplayColumn({
                    id: NEW_CERTIFICATES_LEGEND,
                    name: 'Certificates - Legend',
                    type: LEGEND.type,
                    ...defaultExpandedParams
                })
            ]
        };
    }

    return {
        cols: [
            {
                id: 'NEW CERTIFICATES TOTAL',
                name: '',
                classes: defaultHeaderClass
            }
        ],
        colGroups: [
            [
                {
                    id: NEW_CERTIFICATES_TOTAL,
                    colIds: [NEW_CERTIFICATES_TOTAL],
                    name: 'New Certificates - Total',
                    classes: defaultHeaderClass
                }
            ]
        ],
        nestedData: [
            getCertificateDisplayColumn({
                id: NEW_CERTIFICATES_TOTAL,
                name: 'New Certificates - Total',
                service:
                    certificatesActions.newCertificatesDownloadStudentByType,
                type: NEW_TOTAL.type,
                classroomId
            })
        ]
    };
};

const getSingleClassParticipationTableConfig = ({
    isNewCertificatesExpanded = false,
    isPastCertificatesExpanded = false,
    classroomId
}) => {
    const isExpanded = isNewCertificatesExpanded || isPastCertificatesExpanded;
    const pastCertificatesConfig = getSingleClassParticipationPastCertificates({
        isExpanded: isPastCertificatesExpanded,
        classroomId
    });
    const newCertificatesConfig = getSingleClassParticipationNewCertificates({
        isExpanded: isNewCertificatesExpanded,
        classroomId
    });
    const defaultColGroupStyles = isExpanded
        ? `${css['total-points']} ${css.small}`
        : css['total-points'];
    const defaultColStyles = isExpanded
        ? `${css['total-points']} ${css['col-group-sort-icon']} ${css.small}`
        : `${css['total-points']} ${css['col-group-sort-icon']}`;

    return {
        colGroups: [
            [
                {
                    colIds: [GROUP_NAME],
                    name: 'Table Config - Groups',
                    sort: null,
                    id: GROUP_NAME,
                    classes: css['class-name']
                },
                {
                    colIds: [LIVE_POINTS],
                    name: isExpanded
                        ? 'Points - Live - Small'
                        : 'Points - Live',
                    classes: defaultColGroupStyles
                },
                {
                    colIds: [ACTIVITY_POINTS],
                    name: isExpanded
                        ? 'Points - Curriculum - Small'
                        : 'Points - Curriculum',
                    classes: defaultColGroupStyles
                },
                {
                    colIds: [TOTAL_POINTS],
                    name: isExpanded
                        ? 'Points - Total - Small'
                        : 'Points - Total',
                    classes: defaultColGroupStyles
                },
                ...newCertificatesConfig.colGroups[0],
                ...pastCertificatesConfig.colGroups[0]
            ]
        ],
        cols: [
            {
                id: GROUP_NAME,
                name: '',
                doTranslation: true,
                truncate: true,
                onClick: null
            },
            {
                id: 'LIVE POINTS',
                name: '',
                classes: defaultColStyles,
                sort: headerSort
            },
            {
                id: 'ACTIVITY POINTS',
                name: '',
                classes: defaultColStyles,
                sort: headerSort
            },
            {
                id: 'TOTAL POINTS',
                name: '',
                classes: defaultColStyles,
                sort: headerSort
            },
            ...newCertificatesConfig.cols,
            ...pastCertificatesConfig.cols
        ],
        nestedData: {
            id: 'studentUsageDetails',
            cols: [
                {
                    id: STUDENT_NAME,
                    truncate: true,
                    onClick: () => null, // this is set in the SingleClass component
                    classes: css['student-name']
                },
                {
                    id: LIVE_POINTS,
                    sort: nestedSort
                },
                {
                    id: ACTIVITY_POINTS,
                    sort: nestedSort
                },
                {
                    id: TOTAL_POINTS,
                    sort: nestedSort
                },
                ...newCertificatesConfig.nestedData,
                ...pastCertificatesConfig.nestedData
            ]
        },
        defaultSort: null,
        emptyDataMessage: 'Empty - NoParticipationResults'
    };
};

export { getSingleClassParticipationTableConfig };



// WEBPACK FOOTER //
// ./containers/participation/single-class/single-class-constants-update.js